import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { company, nav } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (window.lenis) {
      window.lenis.scrollTo(`#${id}`, { offset: 0, duration: 1.4 });
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.3, duration: 0.8 }}
      className={`fixed left-0 right-0 top-0 z-[9000] transition-colors duration-500 ${
        scrolled ? "bg-[#0a0a0b]/70 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-5 md:px-12">
        <button onClick={() => go("home")} className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-full bg-[#d4ff4e]" />
          <span className="font-display text-lg font-bold tracking-tight">{company.name}</span>
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {nav.map((n, i) => (
            <button
              key={n.id}
              onClick={() => go(n.id)}
              className="link-underline flex items-center gap-1.5 text-sm text-[#c9c9c4] hover:text-white"
            >
              <span className="font-display text-[10px] text-[#d4ff4e]">0{i + 1}</span>
              {n.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => go("contact")}
          className="hidden rounded-full border border-white/15 px-5 py-2 text-sm text-white transition-colors hover:border-[#d4ff4e] hover:text-[#d4ff4e] md:block"
        >
          Let's talk
        </button>

        <button className="md:hidden" onClick={() => setOpen((o) => !o)} aria-label="menu">
          <div className="flex flex-col gap-1.5">
            <span className={`h-0.5 w-6 bg-white transition-transform ${open ? "translate-y-2 rotate-45" : ""}`} />
            <span className={`h-0.5 w-6 bg-white transition-opacity ${open ? "opacity-0" : ""}`} />
            <span className={`h-0.5 w-6 bg-white transition-transform ${open ? "-translate-y-2 -rotate-45" : ""}`} />
          </div>
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ height: 0 }}
          animate={{ height: "auto" }}
          className="overflow-hidden border-t border-white/10 bg-[#0a0a0b]/95 md:hidden"
        >
          <div className="flex flex-col px-6 py-4">
            {nav.map((n) => (
              <button key={n.id} onClick={() => go(n.id)} className="py-3 text-left text-lg text-[#c9c9c4]">
                {n.label}
              </button>
            ))}
          </div>
        </motion.div>
      )}
    </motion.header>
  );
}
